import {
  TemplateBgColor,
  TemplateSharingAccess,
} from '@distribute/shared/types';
import { SidebarTabLayout } from '../shared/SidebarTabLayout';
import {
  ChangeTemplateDescriptionForm,
  ChangeTemplateNameForm,
} from './components';
import { useDispatch, useSelector } from 'react-redux';
import { templatesModel } from '../../../../../features/templates';
import { RadioButtonForPermissions } from '../../../../../widgets/editor-sidebar/ui/components/RadioButtonForPermissions';
import { RadioButtonForBgColor } from '../../../../../widgets/editor-sidebar/ui/components/RadioButtonForBgColor';

export const TemplateSettingsTab = () => {
  const dispatch = useDispatch();

  const currentTemplate = useSelector(
    templatesModel.selectors.selectCurrentTemplateWithError
  );

  const onChangeSharingAccess = (value: TemplateSharingAccess) => {
    dispatch(
      templatesModel.actions.setCurrentTemplate({
        ...currentTemplate,
        sharingAccess: value,
      })
    );
    dispatch(templatesModel.actions.updateTemplateFromEditor());
  };

  const onChangeBgColor = (value: TemplateBgColor) => {
    dispatch(
      templatesModel.actions.setCurrentTemplate({
        ...currentTemplate,
        bgColor: value,
      })
    );
    dispatch(templatesModel.actions.updateTemplateFromEditor());
  };

  return (
    <div className="w-120">
      <SidebarTabLayout>
        <div className="flex flex-col gap-3 mb-5">
          <p className="text-xs font-semibold text-gray-500 uppercase">
            Template settings
          </p>
          <ChangeTemplateNameForm />
          <ChangeTemplateDescriptionForm />
        </div>
        <div className="flex flex-col gap-3 mb-5">
          <p className="text-xs font-semibold text-gray-500 uppercase">
            Access settings
          </p>
          <div className="flex items-center gap-4">
            {Object.values(TemplateSharingAccess).map((value) => (
              <RadioButtonForPermissions
                name="sharing-access"
                key={value}
                value={value}
                onChange={() => {
                  onChangeSharingAccess(value);
                }}
                defaultChecked={value === currentTemplate.sharingAccess}
              />
            ))}
          </div>
        </div>
        <div className="flex flex-col gap-3 mb-5">
          <p className="text-xs font-semibold text-gray-500 uppercase">
            Appearance
          </p>
          <div>
            <label className="font-semibold text-gray-900 text-md block mb-2">
              Top cover color
            </label>
            <div className="flex gap-3">
              {Object.values(TemplateBgColor).map((value) => (
                <RadioButtonForBgColor
                  name="bg-color"
                  colorValue={value}
                  key={value}
                  value={value}
                  onChange={() => {
                    onChangeBgColor(value);
                  }}
                  defaultChecked={value === currentTemplate.bgColor}
                />
              ))}
            </div>
          </div>
        </div>
      </SidebarTabLayout>
    </div>
  );
};
